var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCapslockRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 42C15.6722 42 15.1184 41.776 14.672 41.328C14.2256 40.88 14.0016 40.3262 14 39.6667C14 39.0056 14.224 38.4518 14.672 38.0053C15.12 37.5589 15.6738 37.3349 16.3333 37.3333H39.6667C40.3278 37.3333 40.8823 37.5573 41.3303 38.0053C41.7783 38.4533 42.0016 39.0071 42 39.6667C42 40.3278 41.776 40.8823 41.328 41.3303C40.88 41.7783 40.3262 42.0016 39.6667 42H16.3333ZM28 19.6L18.9 28.7C18.4722 29.1278 17.9278 29.3417 17.2667 29.3417C16.6056 29.3417 16.0611 29.1278 15.6333 28.7C15.2056 28.2722 14.9917 27.7278 14.9917 27.0667C14.9917 26.4056 15.2056 25.8611 15.6333 25.4333L26.3667 14.7C26.8333 14.2333 27.3778 14 28 14C28.6222 14 29.1667 14.2333 29.6333 14.7L40.3667 25.4333C40.7944 25.8611 41.0083 26.4056 41.0083 27.0667C41.0083 27.7278 40.7944 28.2722 40.3667 28.7C39.9389 29.1278 39.3944 29.3417 38.7333 29.3417C38.0722 29.3417 37.5278 29.1278 37.1 28.7L28 19.6Z",
    fill: "#FDCA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapslockRounded);
export default __webpack_public_path__ + "static/media/capslock-rounded.f37820ed1b87d2c93ffabeda0ada4eac.svg";
export { ForwardRef as ReactComponent };